import { NavigateFunction } from 'react-router';
import { store } from 'redux/store';
import baseApi, { ResponseError } from '../services/api/base';
import handleAtuthorizationErrors from './tokenError';
import sendErrorToSentry from './sendErrorToSentry';
import resetControlPanels from './resetControlPanels';

/* eslint-disable import/prefer-default-export */
export const handleApiError = (
  navigate: NavigateFunction,
  error: ResponseError,
): void => {
  const hasAuthError = handleAtuthorizationErrors(error, navigate);
  if (hasAuthError) return;

  sendErrorToSentry(error);

  // PARSING_ERROR é resposta ilegível — na prática, corpo truncado no meio do stream
  // (visto em produção com o boletim de ~26 MB em base64). Isso é falha de uma request,
  // não estado inválido da aplicação: mandar para /error, zerar o cache do RTK Query e
  // resetar os painéis faz o usuário perder a página inteira por causa de um download.
  // O evento continua indo para o Sentry acima. Mesmo princípio do 403 em bf9c0c96.
  if (error.status === 'PARSING_ERROR') return;

  // navigate ANTES do resetApiState: zerar o cache com a página ainda montada
  // pode re-renderizar com data undefined e crashar no errorElement — #1841 (F4)
  navigate(+error.status === 404 ? '/notfound' : '/error');
  store.dispatch(baseApi.util.resetApiState());
  resetControlPanels();
};
